import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { connect } from "scrivito"
import { ProductInformation } from "shared/types/__generated__/graphql"

import { ProductTenderText } from "entities/products/ui/product-tender-text/ProductTenderText"

type ProductPageTenderTextProps = Omit<
  React.ComponentPropsWithoutRef<"section">,
  "ref"
> & {
  productInformation: ProductInformation | null | undefined
  isLoading?: boolean
}

function ProductPageTenderTextComponent({
  productInformation,
  isLoading,
  className,
  ...rest
}: ProductPageTenderTextProps) {
  const { t } = useTranslation()

  return (
    <ProductTenderText.Root
      productInformation={productInformation}
      isLoading={isLoading}
    >
      <section
        {...rest}
        className={classNames(
          "product-tender-text product-page__tender-text product-page__section card card--elevated",
          className
        )}
      >
        <div className="product-page__section-header">
          <h3 className="product-page__section-title">
            {t("Product.TenderTexts")}
          </h3>
          <ProductTenderText.CopyToClipboard />
        </div>

        <div className="product-tender-text__content">
          <ProductTenderText.GeneralDescription />
          <ProductTenderText.VariantDescription />
        </div>

        <div className="product-page__section-footer">
          <ProductTenderText.CopyToClipboard />
        </div>
      </section>
    </ProductTenderText.Root>
  )
}

export const ProductPageTenderText = React.memo(
  connect(ProductPageTenderTextComponent)
)
